import about from './about';
import auth from './auth';
import general from './general';
import product from './product';

const en = {
  about,
  auth,
  general,
  product,
};

export default en;
